import BaseView from "scripts/views/baseView";
import HorizontalScrollerBehavior from "scripts/hoc/horizontalScrollerBehavior";
import {
  facetLabelForFacetParam,
  facetParamForFacetName,
  facetParamOrder,
} from "scripts/views/search/facetMapper";
import templateFacetedSearchFacetMenu from "templates/search/facetedSearchFacetMenu.hbs";

class FacetedSearchFacetMenuView extends HorizontalScrollerBehavior(BaseView) {
  get template() {
    return templateFacetedSearchFacetMenu;
  }

  get id() {
    return "bb-faceted-search-facet-menu";
  }

  get className() {
    return "faceted-search-facet-menu";
  }

  get events() {
    return {
      "click .bb-faceted-search-facet-menu-button": "onClickFacetButton",
      "click .bb-horizontal-scroller-right-button": "onClickScrollRight",
      "click .bb-horizontal-scroller-left-button": "onClickScrollLeft",
    };
  }

  update() {
    this.render();
  }

  render() {
    const facets = Object.keys(this.collection.facets)
      .map(facetName => {
        const facetParam = facetParamForFacetName(facetName);
        const facetLabel = facetLabelForFacetParam(facetParam);

        if (facetParam && facetLabel) {
          const facetInfo = this.collection.facets[facetName];

          if (
            facetInfo &&
            facetInfo.facetValues &&
            facetInfo.facetValues.length
          ) {
            return { facetParam, facetLabel };
          }
        }

        return null;
      })
      .filter(o => o)
      .sort((a, b) => {
        const aIndex = facetParamOrder.indexOf(a.facetParam);
        const bIndex = facetParamOrder.indexOf(b.facetParam);

        if (aIndex >= 0 && bIndex >= 0) {
          return aIndex - bIndex;
        } else if (aIndex > 0) {
          return -1;
        } else if (bIndex > 0) {
          return 1;
        } else {
          return a.facetLabel.localeCompare(b.facetLabel);
        }
      });

    this.$el.html(this.template({ facets }));

    this.initializeScrollerBehavior();
  }

  onClickFacetButton(e) {
    this.trigger("click", $(e.currentTarget).data("facet-param"));
  }
}

export default FacetedSearchFacetMenuView;
